import { Divider } from '@ankor-io/ui-components'

import { DashboardHeader } from '@/components/dashboard/dashboard-header'
import { FunnelOverview } from '@/components/dashboard/funnel-overview'
import { OnboardingHealth } from '@/components/dashboard/onboarding-health'
import { TransactionVolume } from '@/components/dashboard/transaction-volume'
import { TransactionsStats } from '@/components/dashboard/transactions-stats'

export const DashboardPage = () => {
  return (
    <div
      className="mx-auto w-full max-w-[1600px] space-y-6"
      data-testid="admin-dashboard"
    >
      <DashboardHeader />
      <Divider />
      <FunnelOverview />
      <Divider />
      <OnboardingHealth />
      <Divider />
      <TransactionsStats />
      <Divider />
      <TransactionVolume />
    </div>
  )
}
